import { useTranslation } from "react-i18next";
import styles from "../SsnCardVerification.module.scss";
import { usePageView } from "../../../shared/analytics/usePageView";
import { DOCUMENT_CAPTURE_EVENTS, DOCUMENT_CAPTURE_SECTIONS } from "../../../shared/analytics/documentCaptureEvents";

interface ProcessingScreenProps {
  showSpinner: boolean;
  onHideAnimation: () => void;
}

/**
 * ProcessingScreen — shown while the hook POSTs the captured images and polls
 * the backend for the outcome (state `processing`). Mirrors legal-id's
 * ProcessingScreen: a title, a toggle-able spinner, and a hide/show-animation
 * link for users who prefer not to watch the animation during the poll.
 */
export function ProcessingScreen({ showSpinner, onHideAnimation }: ProcessingScreenProps) {
  const { t } = useTranslation();
  usePageView(DOCUMENT_CAPTURE_EVENTS.VIEWED.PROCESSING_SCREEN, "section", { section: DOCUMENT_CAPTURE_SECTIONS.PROCESSING });

  return (
    <div className={styles.card}>
      <h2 className={styles.processingTitle}>{t('ssnCard.processing.title')}</h2>

      {showSpinner && <div className={styles.processingSpinner} />}

      <p className={styles.processingSubtitle}>{t('ssnCard.processing.subtitle')}</p>

      <button
        type="button"
        className={styles.hideAnimationLink}
        onClick={onHideAnimation}
      >
        {showSpinner ? t('ssnCard.processing.hideAnimation') : t('ssnCard.processing.showAnimation')}
      </button>
    </div>
  );
}
